export class LoadPartnerTypesAction {
  static type = '[PartnerTypes] LoadPartnerTypesAction';
}

export class ClearPartnerTypesAction {
  static type = '[PartnerTypes] ClearPartnerTypesAction';
}
